if (!customElements.get('dhs-search')) {
  customElements.define('dhs-search', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.dhs-search-panel');
      this.initial = this.querySelector('[data-search-initial]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.all = this.querySelector('[data-search-all]');
      this.input.addEventListener('focus', () => this.open(), options);
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.request?.abort();
        this.version = (this.version || 0) + 1;
        this.open();
        const hasQuery = !!this.input.value.trim();
        this.initial.hidden = hasQuery;
        this.results.hidden = true;
        this.all.href = `${this.form.action}?q=${encodeURIComponent(this.input.value.trim())}`;
        if (!hasQuery) { this.status.textContent = ''; return; }
        this.status.textContent = 'Loading search results';
        this.timer = setTimeout(() => this.search(this.version), 250);
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.input.focus({ preventScroll: true }); this.close(); return; }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault(); this.open();
        const items = [this.input, ...Array.from(this.panel.querySelectorAll('a')).filter(a => a.getClientRects().length)];
        const index = items.indexOf(document.activeElement);
        items[(index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length].focus({ preventScroll: true });
      }, options);
      this.reposition = () => { if (!this.panel.hidden) this.positionPanel(); };
      window.addEventListener('resize', this.reposition, options);
      window.addEventListener('scroll', this.reposition, { ...options, passive: true });
    }
    positionPanel() {
      const rect = this.form.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const gap = viewportWidth < 990 ? 15 : 16;
      const panelWidth = viewportWidth < 990 ? viewportWidth - gap * 2 : Math.min(Math.max(rect.width, 860), viewportWidth - gap * 2);
      const left = viewportWidth < 990 ? gap : Math.min(Math.max(gap, rect.left), viewportWidth - panelWidth - gap);
      const top = Math.max(8, rect.bottom + 8);
      this.panel.style.setProperty('--dhs-search-panel-left', `${Math.round(left)}px`);
      this.panel.style.setProperty('--dhs-search-panel-top', `${Math.round(top)}px`);
      this.panel.style.setProperty('--dhs-search-panel-width', `${Math.round(panelWidth)}px`);
    }
    open() { this.positionPanel(); this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
    async search(version) {
      this.request = new AbortController();
      try {
        const params = new URLSearchParams({ q: this.input.value.trim(), 'resources[type]': 'query,product,collection', 'resources[limit]': '4', 'resources[limit_scope]': 'each', section_id: 'dhs-predictive-search' });
        const response = await fetch(`${this.dataset.endpoint}?${params}`, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (version !== this.version) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.results.innerHTML = doc.querySelector('#shopify-section-dhs-predictive-search')?.innerHTML || '';
        this.results.hidden = false;
        this.positionPanel();
        this.status.textContent = `${this.results.querySelectorAll('.dhs-search-product').length} products found`;
      } catch (error) {
        if (error.name !== 'AbortError' && version === this.version) {
          this.status.textContent = 'Suggestions unavailable. Use View all results to search.';
        }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.request?.abort(); clearTimeout(this.timer); }
  });
}